export const ApplicationConstant = {
    ApplicationID : 29,
    clientId : 17,
    DEFAULT_DATE_FORMAT: 'YYYY-MM-DD'
};
